// extracted by mini-css-extract-plugin
export default {"imageWrapper":"qI-z","hovered":"rI-z","hoverImage":"sI-z","mainImage":"tI-z","imageNoBackground":"uI-z","fullSizeImage":"vI-z"};